(function () {
    'use strict';

    angular
        .module('travelExpenses')
        .controller('RevertTravelExpensesController', RevertTravelExpensesController);

        RevertTravelExpensesController.$inject = ['$uibModalInstance', 'expense', 'expensesList', 'TravelExpenseService', 'toastr', 'travelExpenseController'];

    function RevertTravelExpensesController($uibModalInstance, expense, expensesList, TravelExpenseService, toastr, travelExpenseController) {
        var vm = this;
        vm.expense = expense;
        vm.expensesList = expensesList;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            vm.query = [];
            vm.query['id'] = vm.expense.id;
            TravelExpenseService.revertPaymentTravelExpense(vm.query).then(function(response) {
                console.log(response);
                if(response.data.error) {
                    toastr.error(response.data.msg);
                } else {
                    toastr.success(response.data.msg);
                    travelExpenseController.getByFilter();
                    //vm.expensesList.splice(vm.expensesList.indexOf(expense), 1);
                    // if(vm.expensesList.length==0){
                    //     vm.flag = false;
                    // }
                }
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();